export default {
  /**
   * Set default publisher
   * @param {Object} state
   * @param {Object} publisher
   */
  setDefaultPublisher(state, publisher) {
    state.defaultPublisher = publisher;
  },

  /** Set self audio status */
  setPublisherAudioEnabled(state, isEnabled) {
    state.publisherAudioEnabled = isEnabled;
  },
  /** Set self video status */
  setPublisherVideoEnabled(state, isEnabled) {
    state.publisherVideoEnabled = isEnabled;
  },

  /** Set muted state */
  setSubscriberAudioLevel(state, level) {
    state.subscriberAudioLevel = level;
  },
  /** Set muted state */
  setSubscriberAudioEnabled(state, isEnabled) {
    state.subscriberAudioEnabled = isEnabled;
  }
};
